import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "60",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z\" fill=\"#888\"></path><rect x=\"6\" y=\"30\" width=\"11\" height=\"4\" rx=\"1\" fill=\"#fff\"></rect><rect x=\"19\" y=\"30\" width=\"10\" height=\"4\" rx=\"1\" fill=\"#fff\"></rect><rect x=\"31\" y=\"30\" width=\"10\" height=\"4\" rx=\"1\" fill=\"#fff\"></rect><rect x=\"43\" y=\"30\" width=\"11\" height=\"4\" rx=\"1\" fill=\"#fff\"></rect><rect x=\"43\" y=\"5\" width=\"11\" height=\"7\" rx=\"1\" fill=\"#C4C4C4\"></rect>", 6)
  ]))]))
}
export default { render };